import { render, staticRenderFns } from "./expansionPanel.vue?vue&type=template&id=705e929e&scoped=true"
import script from "./expansionPanel.vue?vue&type=script&lang=js"
export * from "./expansionPanel.vue?vue&type=script&lang=js"
import style0 from "./expansionPanel.vue?vue&type=style&index=0&id=705e929e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705e929e",
  null
  
)

export default component.exports